import userAgent from 'bowser'

function browser () {
  return userAgent.name.replace(' ', '-').toLowerCase()
}
function browserVersion () {
  return Math.floor(userAgent.version)
}
function os () {
  return userAgent.osname.replace(' ', '-').toLowerCase()
}
function osVersion () {
  return Math.floor(userAgent.osversion)
}

export default {
  browser: {
    name: browser(),
    version: browserVersion()
  },
  os: {
    name: os(),
    version: osVersion()
  }
}



// WEBPACK FOOTER //
// ./src/library/core/userAgent.js